import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { Notification } from "../../Common/KendoHelpers";

export class AccountSelector {
    private static readonly ACCOUNT_SELECTOR = '#portfolioAccountSelector';

    private refreshPageOnAccountChange: boolean = false;
    constructor(refreshPageOnAccountChange: boolean) {
        this.refreshPageOnAccountChange = refreshPageOnAccountChange;
        this.create();
    }

    private create() {
        const self = this;

        const dataSourceOptions: kendo.data.DataSourceOptions = {
            transport: {
                read: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_ACCOUNT_NUMBERS,
            },
            error: (e: kendo.data.DataSourceErrorEvent) => {
                const notification = new Notification();
                notification.error('No data found to display');
            },
        }

        const dropDownList = $(AccountSelector.ACCOUNT_SELECTOR).kendoDropDownList({
            optionLabel: "Select Account...",
            height: 200,
            dataTextField: 'account',
            dataValueField: 'account',
            dataBound: () => {
                const account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
                if (account?.length == 0 || !dropDownList) {
                    return;
                }

                const dropDownData = dropDownList.dataSource.data();
                for (let i = 0; i < dropDownData.length; ++i) {
                    const dropDownAccount = (dropDownData[i] as any).account;
                    if (dropDownAccount == account) {
                        dropDownList.select(i + 1);
                    }
                }
            },
            change: (e: kendo.ui.DropDownListChangeEvent) => {
                self.onChange(e.sender.value());
            },
            dataSource: new kendo.data.DataSource(dataSourceOptions),
        }).data('kendoDropDownList');
    }

    private onChange(account: string) {
        CookieHelper.set(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE, account);
        if (this.refreshPageOnAccountChange) {
            window.location.reload();
        }
    }
}
